import {environment} from '@env/environment';

export const oidc = {
  clientId: environment.clientId,
  issuer: environment.issuer,
  redirectUri: environment.redirectUri,
  scope: environment.scope
};
